import styled from "@emotion/styled";
import { Stack } from "@mui/material";

export const Wrapper = styled.div`
  margin-bottom: ${p => p.theme.space[6]}px;

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    margin-bottom: ${p => p.theme.space[7]}px;
  }
`;

export const StyledStack = styled(Stack)`
  font-size: ${p => p.theme.fontSizes.m};
  font-weight: ${p => p.theme.fontWeight.medium};

  color: ${p => p.theme.colors.secondary.gray};
`;
